var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.authorizedDisabled},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_c('v-icon',_vm._b({class:_vm.className,attrs:{"color":_vm.color,"disabled":_vm.authorizedDisabled || _vm.disabled},on:{"click":_vm.click}},'v-icon',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)]}}])},[_c('span',[_vm._v("権限がありません")])])}
var staticRenderFns = []

export { render, staticRenderFns }